import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';
import { TranslationService } from '../../../translations/Translation.service';

@Component({
    selector: 'access-level-header-tooltip',
    templateUrl: './access-level-header-tooltip.component.html',
    styleUrls: ['./access-level-header-tooltip.component.less'],
    standalone: false
})
export class AccessLevelHeaderTooltipComponent implements ITooltipAngularComp {
    private params!: ITooltipParams;

    constructor(public TR: TranslationService) {}

    agInit(params: ITooltipParams): void {
        this.params = params;
    }

    tooltipHtml(): string {
        return this.TR.key('userManagement.accessLevel.tooltip');
    }
}
